import { ProductCard as ProductCardHOC } from './ProductCard';
import { ProductCardHOCProps } from '../interfaces/interfaces';

import { ProductButtons } from './ProductButtons';
import { ProductImage } from './ProductImage';
import { ProductNombre } from './ProductNombre';
import { ProductSKU } from './ProductSKU';
import { ProductMoneda } from './ProductMoneda';
import { ProductPrecio } from './ProductPrecio';
import { ProductExistencia } from './ProductExistencia';





export { ProductButtons } from './ProductButtons';
export { ProductImage } from './ProductImage';
export { ProductNombre } from './ProductNombre';
export { ProductSKU } from './ProductSKU';
export { ProductMoneda } from './ProductMoneda';
export { ProductPrecio } from './ProductPrecio';
export { ProductExistencia } from './ProductExistencia';




export const ProductCard: ProductCardHOCProps = Object.assign(ProductCardHOC, {
    Nombre: ProductNombre,
    Imagen: ProductImage,
    Buttons: ProductButtons,
    SKU: ProductSKU,
    Moneda: ProductMoneda,
    Precio: ProductPrecio,
    Existencia: ProductExistencia
})


export default ProductCard;

